'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deleteListItemFile;

var _respToJson = require('../respToJson');

var _respToJson2 = _interopRequireDefault(_respToJson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Delete file from list item attachments.
 *
 * @param {string} list Name of list.
 * @param {string} id Id of item.
 * @param {string} filename Name of file to delete.
 * @return {Promise}
 */
function deleteListItemFile(list, id, filename) {
    var siteurl = window._spPageContextInfo.webServerRelativeUrl;
    var urlTemplate = siteurl + '/_api/web/lists/getByTitle(\'' + list + '\')/items(' + id + ')/AttachmentFiles/getByFileName(\'' + filename + '\')';
    var requestDigest = document.getElementById('__REQUESTDIGEST');

    return fetch(urlTemplate, {
        credentials: 'same-origin',
        method: 'DELETE',
        headers: {
            'Accept': 'application/json;odata=verbose',
            'Content-Type': 'application/json;odata=verbose',
            'X-RequestDigest': requestDigest && requestDigest.value || ''
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/deleteListItemFile.js
// module id = 1046
// module chunks = 0